<template>
    <div class="text-center mb-5">
        <p class="text-[16px] leading-[1]">Din tid:</p>
        <p class="text-[18px] leading-[1.6] font-medium text-darkPurple text-center shadowed-text" v-html="time"></p>
    </div>
</template>

<script>
export default {
    name: 'Timer',
    props: {
        time: {
            type: String,
            required: true,
            default: '00:00:00'
        },
    },
}
</script>